<form *ngIf="incidentFormGroup" [formGroup]="incidentFormGroup">
  <div class="grid">
    <div class="col-12 input-field">
      <label for="date">Fecha</label>
      <p-calendar [firstDayOfWeek]="1" formControlName="date" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
          [yearNavigator]="true" dateFormat="dd/mm/yy" [showTime]="true" d-form-field-error></p-calendar>
  </div>
      <div class="col-12 input-field">
          <label for="source">Origen</label>
          <p-dropdown id="source" [options]="sources" optionLabel="name" optionValue="id" appendTo="body"
             formControlName="source" showClear placeholder="Seleccione una opción" (onChange)="onSourceChange($event)"
              filterBy="name"></p-dropdown>
      </div>
      
      <div class="col-12 input-field">
          <label for="thirdPartyId">Selecciones</label>
          <p-dropdown id="thirdPartyId" [options]="thirdParties" optionLabel="name" optionValue="id" appendTo="body"
              formControlName="thirdPartyId" showClear [filter]="true"
              filterBy="name"></p-dropdown>
      </div>

      <div class="col-12 input-field">
        <label for="incidentTypeId">Tipo de incidencia</label>
        <p-dropdown id="incidentTypeId" [options]="incidentTypes" optionLabel="name" optionValue="id" appendTo="body"
            formControlName="incidentTypeId" showClear [filter]="true"
            filterBy="name"></p-dropdown>
    </div>

    <div class="col-12 input-field">
      <label for="isApplicable">Procede</label>
      <!--<p-inputSwitch id="isApplicable"  formControlName="isApplicable"></p-inputSwitch>-->
      <p-dropdown id="isApplicable" [options]="isApplicableOptions" optionLabel="name" optionValue="id" appendTo="body"
          formControlName="isApplicable" showClear [filter]="true"
          filterBy="name"></p-dropdown>
  </div>
      <div class="col-12 input-field">
        <label for="notes">Descripción</label>
        <textarea pInputTextarea formControlName="description" rows="4"  d-form-field-error></textarea>
    </div>
  </div>
  <div class="mt-4 flex justify-content-between">
      <p-button label="Eliminar" icon="pi pi-trash" styleClass="p-button-danger" (click)="delete()"
          *ngIf="incident.id && allowDelete"></p-button>
      <div class="flex gap-2">
          <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
          <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
              (click)="save()"></p-button>
      </div>
  </div>
</form>